import Api from './services/api.service';
import QueryString from './services/query-string.service';
import Cidades from './services/cidades.service';
import Fretes from './services/fretes.service';
import Empresas from './services/empresas.service';
import Usuario from './services/usuario.service';
import Navegacao from './services/navegacao.service';
import ScrollControl from './decorators/scroll-control/scroll-control.service';
import mask from './filters/mask.filter';
import mapa from './components/mapa/mapa.config';
import grafico from './components/grafico/grafico-historico-preco.directive';
import cnpjDirective from './decorators/cnpj.directive';
import cpfDirective from './decorators/cpf.directive';
import errSrcDirective from './decorators/err-src.directive';
import layoutFillHeight from './decorators/layout-fill-height.directive';
import scrollToTopDirective from './decorators/scroll-to-top.directive';
import scrollControl from './decorators/scroll-control/scroll-control.directive';

export default (ngModule) => {
  ngModule
    .service('Api', Api)
    .service('QueryString', QueryString)
    .service('Cidades', Cidades)
    .service('Fretes', Fretes)
    .service('Empresas', Empresas)
    .service('Usuario', Usuario)
    .service('Navegacao', Navegacao)
    .service('ScrollControl', ScrollControl)
    .filter('mask', mask);

  mapa(ngModule);
  grafico(ngModule);
  cnpjDirective(ngModule);
  cpfDirective(ngModule);
  errSrcDirective(ngModule);
  layoutFillHeight(ngModule);
  scrollToTopDirective(ngModule);
  scrollControl(ngModule);
};



/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./common/common.config.ts
 **/